import { Link } from 'react-router-dom';

const SERVICES = [
  {
    icon: 'ri-brain-line',
    title: 'AI-Powered Solutions',
    desc: 'Custom machine learning, chatbots, predictive analytics, and RPA automation built for your business processes.',
    features: ['Machine Learning Models', 'Conversational AI', 'Predictive Analytics', 'Process Automation'],
    accent: 'teal',
    href: '/services#ai-solutions',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Tailored Development',
    desc: 'Web, Windows, and Mobile applications built from scratch — architected for performance, security, and scale.',
    features: ['Web Applications', 'Windows Desktop Apps', 'Mobile (iOS & Android)', 'API & Integrations'],
    accent: 'emerald',
    href: '/services#tailored-solutions',
  },
  {
    icon: 'ri-apps-line',
    title: 'Proprietary Products',
    desc: 'Ready-to-deploy business software products — from POS and RFID systems to design tools and publishing suites.',
    features: ['POS Solution', 'RFID Solutions', 'Inventory Management', 'Ship Chandling System'],
    accent: 'amber',
    href: '/services#products',
  },
];

export default function ServicesOverview() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          {/* <span className="inline-block bg-teal-100 text-teal-700 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-4">
            What We Do
          </span> */}
          <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            End-to-End IT Solutions
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            From intelligent AI systems to enterprise software products — we deliver solutions that transform how businesses operate.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-7">
          {SERVICES.map((svc) => (
            <div
              key={svc.title}
              className="bg-white border border-gray-100 rounded-2xl p-8 hover:border-teal-200 transition-all duration-300 group"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-2xl mb-6 ${
                svc.accent === 'teal' ? 'bg-teal-100 text-teal-600' :
                svc.accent === 'emerald' ? 'bg-emerald-100 text-emerald-600' :
                'bg-amber-100 text-amber-600'
              }`}>
                <i className={`${svc.icon} text-2xl`} />
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-3">{svc.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-6">{svc.desc}</p>

              <ul className="space-y-2.5 mb-8">
                {svc.features.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-check-line text-teal-500" /> {f}
                  </li>
                ))}
              </ul>

              <Link
                to={svc.href}
                className={`cursor-pointer whitespace-nowrap inline-flex items-center gap-2 text-sm font-semibold transition-colors ${
                  svc.accent === 'amber'
                    ? 'text-amber-600 hover:text-amber-700'
                    : 'text-teal-600 hover:text-teal-700'
                }`}
              >
                Explore Service <i className="ri-arrow-right-line" />
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/services"
            className="cursor-pointer whitespace-nowrap inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white font-semibold px-8 py-3.5 rounded-lg transition-colors"
          >
            View All Services <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
